export const HEADER_SIZES = {
  SM: 'sm',
  MD: 'md',
  MD_NEXT: 'md-next',
  LG: 'lg',
  FULL: 'full',
  FULL_NEXT: 'full-next'
}
